import styled from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes } from "@similarweb/styles";

export const AccordionWrapper = styled.div<{ isOpen?: boolean }>`
    background-color: rgb(236, 241, 255);
    border-radius: 6px;
    &:hover {
        transition: all ease-in 0.3s;
        box-shadow: ${({ isOpen }) => (isOpen ? "none" : "0 3px 6px rgba(14, 30, 62, 0.08)")};
        background-color: ${({ isOpen }) => (isOpen ? "rgb(236, 241, 255)" : colorsPalettes.blue[100])};
    }
`;

export const AccordionHeadContainer = styled(FlexRow)<{ isOpen?: boolean }>`
    padding: ${({ isOpen }) => (isOpen ? "20px 32px 20px 24px" : "24px 32px 24px 24px")};
    align-items: center;
    justify-content: space-between;
    transition: padding 0.2s ease-out;
    gap: 16px;
    cursor: pointer;
`;
